import React, { Component } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import {themeColorLogo} from '../../../src/App'

class user extends Component
{
    constructor(props)
    {
        super(props)
        this.state = {
            user: null,
        }
    }
    render(){
        if(!this.props.user) return null;
        var data = JSON.stringify(this.props.user);
        var user  = JSON.parse(data);
        return(
            <div>
            {this.props.show_username_logo_fio === 0 &&
            <div className="ItemUser">
            <ListItem>
                    <ListItemIcon>
                        
                        <AccountCircleIcon style={{fontSize: 50, color: themeColorLogo.color, zIndex: 1}}></AccountCircleIcon>
                        <Brightness1Icon style={{fontSize: 50, color: 'white', position: 'absolute'}}></Brightness1Icon>
                    </ListItemIcon>
                    <label className="username">{user.data.name}</label>
            </ListItem>
            </div>
            }
            {this.props.show_username_logo_fio === 1 &&
            <div className="ItemUser">
            <ListItem>
                    <label className="username">{user.data.name}</label>
            </ListItem>
            </div>
            }
            {this.props.show_username_logo_fio === 2 &&
            <div className="ItemUser">
            </div>
            }
            </div>
        );
    }

}
export default user;